import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand315: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="expand-315, enlarge"><path d="M10.25 3.75H3.75V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 13.75V20.25H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.52344 4.52344L10.25 10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 13.75L19.4766 19.4766" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExpand315;
